import { action } from 'mobx';
import gql from "../utils/gql";
import axios from "axios";
import {Common as util} from "../utils/common";

export class Board {

  @action getBoardList = (data, cb) => {

    let property = ['page', 'limit', 'sort', 'searchParams']
    let variables = util.getDataStByKey(data, property);

    let params = {
      type: 'query',
      operation: 'getBoardList',
      variables: variables,
      getData: 'docs, totalDocs, limit, page, nextPage, prevPage, totalPages, pagingCounter, meta'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if(res.status === 200) {
            if(typeof cb === 'function') {
              cb(res.data.data[params.operation]);
            }
            else {
              return res.data.data[params.operation];
            }
          }

        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };

  @action updateBoard = (data, cb) => {


    let params = {
      type: 'mutation',
      operation: 'updateBoard',
      variables: data,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if(res.status === 200) {
            if(typeof cb === 'function') {
              cb(res.data.data[params.operation]);
            }
            else {
              return res.data.data[params.operation];
            }
          }

        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };

  @action removeBoard = (data, cb) => {


    let params = {
      type: 'mutation',
      operation: 'removeBoard',
      variables: data,
      getData: 'data'
    };

    const gpqParams = gql(params);

    return axios.post('/', gpqParams)
        .then(function (res) {
          if(res.status === 200) {
            if(typeof cb === 'function') {
              cb(res.data.data[params.operation]);
            }
            else {
              return res.data.data[params.operation];
            }
          }

        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
  };
}

export default new Board();
